let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2Yn3Z")).then(() => parcelRequire('e8Z1Y'));